import React, { useEffect, useState, useMemo } from "react";
import CartItem from "./CartItem";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCart } from "../../../Redux/Customers/Cart/Action";
import Navbar from "../../../components/Navbar";
import { Loader } from "../../../components/Loader";
import Footer from "../../../components/Footer";

const Cart = () => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const jwt = localStorage.getItem("jwt");
  const { cart } = useSelector((store) => store);

  useEffect(() => {
    setLoading(true);
    dispatch(getCart(jwt)).finally(() => {
      setLoading(false);
    });
  }, [jwt, dispatch]);

  const totalPrice = useMemo(() => {
    return cart?.cartItems?.reduce((total, item) => {
      // Use the price directly from the item as it is already multiplied by quantity
      return total + item?.price;
    }, 0);
  }, [cart?.cartItems]);

  const totalDiscountedPrice = useMemo(() => {
    return cart?.cartItems?.reduce((total, item) => {
      // Use the discountedPrice directly from the item as it is already multiplied by quantity
      return total + item?.discountedPrice;
    }, 0);
  }, [cart?.cartItems]);

  const totalDiscount = useMemo(() => {
    return totalPrice - totalDiscountedPrice;
  }, [totalPrice, totalDiscountedPrice]);


  const totalItems = cart?.cartItems?.reduce((total, item) => total + item?.quantity, 0);


  if (loading) {
    return <Loader />;
  }

  return (
    <div className="bg-black min-h-screen h-fit">
      <Navbar />
      <div className="p-8 md:p-16 lg:p-36">
        {cart?.cartItems?.length > 0 ? (
          <div className="lg:grid grid-cols-3 lg:px-16 relative">
            <div className="lg:col-span-2 lg:px-5 bg-[#000] text-white">
              <div className="space-y-3">
                {cart?.cartItems?.map((item) => (
                  <CartItem key={item?._id} item={item} showButton={true} />
                ))}
              </div>
            </div>
            <div className="px-5 sticky top-0 h-[100vh] mt-5 lg:mt-0">
              <div className="border p-5 bg-black text-white shadow-lg rounded-md">
                <p className="font-bold opacity-60 pb-4">PRICE DETAILS</p>
                <hr />
                <div className="space-y-3 font-semibold">
                  <div className="flex justify-between pt-3">
                    <span>Price ({totalItems} item{totalItems > 1 ? 's' : ''})</span>
                    <span>₹{totalPrice}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Discount</span>
                    <span className="text-green-700">-₹{totalDiscount}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Delivery Charges</span>
                    <span className="text-green-700">Free</span>
                  </div>
                  <hr />
                  <div className="flex justify-between font-bold text-lg">
                    <span>Total Amount</span>
                    <span className="text-green-700">₹{totalDiscountedPrice}</span>
                  </div>
                </div>

                <Button
                  onClick={() => navigate("/checkout?step=2")}
                  variant="contained"
                  type="submit"
                  sx={{ padding: ".8rem 2rem", marginTop: "2rem", width: "100%" }}
                >
                  Check Out
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center text-center text-white space-y-5 py-20">
            <div className="text-4xl font-extrabold">No Products Found</div>
            <p className="text-lg text-gray-400">Looks like your cart is empty.</p>
            <img
              src="/emptyCart.png"
              alt="Gaming empty cart"
              className="w-64 h-64 opacity-75"
            />
            <Button
              onClick={() => navigate("/home")}
              variant="contained"
              sx={{ padding: ".8rem 2rem", width: "fit-content" }}
            >
              Start Shopping
            </Button>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Cart;
